import { Badge } from "@chakra-ui/react";

const STATUS_STYLES = {
    active: { bg: "green.100", borderColor: "green.200", color: "green.700", label: "Aktywna" },
    draft: { bg: "gray.100", borderColor: "gray.200", color: "gray.700", label: "Wersja robocza" },
    inactive: { bg: "orange.100", borderColor: "orange.200", color: "orange.700", label: "Wstrzymana" },
};

export const CampaignStatusBadge = ({ status, badgeStyles }) => {
    const key = status?.toLowerCase();
    const { bg, borderColor, color, label } = STATUS_STYLES[key] ?? STATUS_STYLES.inactive;

    return (
        <Badge bg={bg} borderColor={borderColor} color={color} borderWidth={1} variant="subtle" fontSize="xs" px={3} py={0.5} borderRadius={6} {...badgeStyles}>
            {label}
        </Badge>
    );
};

export default CampaignStatusBadge;
